import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="impact-conversion-outcome"
export default class extends Controller {

}
